export default __webpack_public_path__ + "static/media/lds-logo_sq.cf11195cfafd34d4.svg";